import React, { useState } from 'react';
import { MenuIcon, XIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
import { trackCtaClick } from '../lib/analytics';

const primaryLinks = [
  { to: '/pricing', label: 'Pricing' },
  { to: '/self-managed-strata-software', label: 'Self-Managed' },
  { to: '/compliance/nsw-strata', label: 'Compliance' },
  { to: '/benchmark-report-small-strata-operations', label: 'Benchmark' },
  { to: '/resources/pr-hub', label: 'Resources' },
  { to: '/contact', label: 'Contact' }
];

export function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <header className="w-full bg-white shadow-sm sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center py-4 md:space-x-6">
          <Link to="/" className="flex items-center">
            <span className="text-blue-600 font-bold text-2xl">
              Strata<span className="text-slate-800">Pro</span>
            </span>
          </Link>

          <div className="hidden md:flex items-center space-x-6">
            {primaryLinks.map((link) => (
              <Link key={link.to} to={link.to} className="text-sm font-medium text-gray-600 hover:text-gray-900">
                {link.label}
              </Link>
            ))}
          </div>

          <div className="hidden md:flex items-center">
            <Link to="/get-started" onClick={() => trackCtaClick('Get Started', 'header')} className="whitespace-nowrap inline-flex items-center justify-center px-4 py-2 rounded-md text-sm font-medium text-white bg-blue-600 hover:bg-blue-700">
              Get Started
            </Link>
          </div>

          <button
            type="button"
            className="md:hidden inline-flex items-center justify-center p-2 rounded-md text-gray-500 hover:bg-gray-100"
            onClick={() => setIsMenuOpen((v) => !v)}
          >
            <span className="sr-only">Toggle menu</span>
            {isMenuOpen ? <XIcon className="h-6 w-6" /> : <MenuIcon className="h-6 w-6" />}
          </button>
        </div>
      </div>

      {isMenuOpen && (
        <div className="md:hidden border-t bg-white">
          <nav className="px-4 py-4 grid gap-3">
            {primaryLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className="text-base font-medium text-gray-800"
                onClick={() => setIsMenuOpen(false)}
              >
                {link.label}
              </Link>
            ))}
            <Link
              to="/get-started"
              className="mt-2 w-full text-center px-4 py-2 rounded-md text-sm font-medium text-white bg-blue-600"
              onClick={() => setIsMenuOpen(false)}
            >
              Get Started
            </Link>
          </nav>
        </div>
      )}
    </header>
  );
}
